import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=30074b2a&scoped=true&"
import script from "./ProductPage.vue?vue&type=script&lang=js&"
export * from "./ProductPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=30074b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30074b2a",
  null
  
)

export default component.exports